module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="filter_media">\n    <div class="filter_radio_container">\n        <input class="filter_radio" id="filter_all_media" type="radio" name="media_filter" value="ALL_MEDIA" checked="true" />\n        <label for="filter_all_media" tabindex="0">' +
((__t = ( I18n.t('uploader.source.gphotos.all') )) == null ? '' : __t) +
'</label>\n	</div>\n    <div class="filter_radio_container">\n            <input class="filter_radio" id="filter_video" type="radio" name="media_filter" value="VIDEO" />\n            <label for="filter_video" tabindex="0">' +
((__t = ( I18n.t('uploader.source.gphotos.video') )) == null ? '' : __t) +
'</label>\n    </div>\n    <div class="filter_radio_container">\n            <input class="filter_radio" id="filter_photo" type="radio" name="media_filter" value="PHOTO">\n            <label for="filter_photo" tabindex="0">' +
((__t = ( I18n.t('uploader.source.gphotos.photo') )) == null ? '' : __t) +
'</label>\n    </div>\n</div>\n\n<div id="filter_content">\n    <div class="prompt">' +
((__t = ( I18n.t('uploader.source.gphotos.filter.prompt') )) == null ? '' : __t) +
'</div>\n    <ul>\n        <li id="filter_by_category" class="filter_item filter_by" data-filter="category" tabindex="0">\n            ' +
((__t = ( I18n.t('uploader.source.gphotos.filter.category') )) == null ? '' : __t) +
'\n            (<span class="category_count">0</span>)\n        </li>\n        <li id="filter_by_date" class="filter_item filter_by" data-filter="date" tabindex="0">\n            ' +
((__t = ( I18n.t('uploader.source.gphotos.filter.date') )) == null ? '' : __t) +
'\n        </li>\n        <li id="reset_all_filters" tabindex="0">\n            ' +
((__t = ( I18n.t('uploader.source.gphotos.filter.reset_all') )) == null ? '' : __t) +
'\n        </li>\n    </ul>\n</div>\n\n<div id="filter_drop_panel">\n    <button id="drop_panel_close" tabindex="0">\n        ' +
((__t = ( I18n.t('uploader.source.gphotos.filter.close') )) == null ? '' : __t) +
'\n    </button>\n\n    <!-- category options -->\n    <div id="category_options" class="indicator">\n        <div class="prompt">' +
((__t = ( I18n.t('uploader.source.gphotos.filter.drop_prompt') )) == null ? '' : __t) +
'</div>\n        <ul id="category_list">\n            ';
 for(var i = 0; i < getCategoryFilters().length; i++) { ;
__p += '\n                <li class="filter_checkbox_container">\n                    <input class="filter_checkbox" id="' +
((__t = ( getCategoryFilters(i).toLowerCase() )) == null ? '' : __t) +
'" type="checkbox" value="' +
((__t = ( getCategoryFilters(i).toUpperCase() )) == null ? '' : __t) +
'">\n                    <label for="' +
((__t = ( getCategoryFilters(i).toLowerCase() )) == null ? '' : __t) +
'" tabindex="0">' +
((__t = ( getCategoryFilters(i) )) == null ? '' : __t) +
'</label>\n                </li>\n            ';
 } ;
__p += '\n	</ul>\n    </div>\n\n	<!-- date options -->\n	<div id="date_options" class="indicator">\n		<div class="dropdown_wrapper column_year">\n			<label>' +
((__t = ( I18n.t('uploader.common.filter.year') )) == null ? '' : __t) +
'</label>\n			<div id="year_selector" class="filter_item date_selector" data-date-selector="year" tabindex="0">' +
((__t = ( I18n.t('uploader.common.filter.none') )) == null ? '' : __t) +
'</div>\n			<ul id="year_dropdown" class="date_dropdown">\n				';
 for(var i = 0; i < getYears().length; i++) { ;
__p += '\n					<li class="date_dropdown_item">\n						<input type="radio" id="year_' +
((__t = ( getYears(i) )) == null ? '' : __t) +
'" value="' +
((__t = ( getYears(i) )) == null ? '' : __t) +
'" name="select_year" data-date-filter="year" />\n						<label for="year_' +
((__t = ( getYears(i) )) == null ? '' : __t) +
'" tabindex="0">' +
((__t = ( getYears(i) )) == null ? '' : __t) +
'</label>\n					</li>\n				';
 } ;
__p += '\n			</ul>\n		</div>\n		<div class="dropdown_wrapper column_month">\n			<label>' +
((__t = ( I18n.t('uploader.common.filter.month') )) == null ? '' : __t) +
'</label>\n			<div id="month_selector" class="filter_item date_selector" data-date-selector="month" tabindex="0">' +
((__t = ( I18n.t('uploader.common.filter.none') )) == null ? '' : __t) +
'</div>\n			<ul id="month_dropdown" class="date_dropdown" data-date-filter="month">\n				';
 for(var i = 1; i <= getMonths().length; i++) { ;
__p += '\n					<li class="date_dropdown_item">\n						<input type="radio" id="month_' +
((__t = ( i )) == null ? '' : __t) +
'" value="' +
((__t = ( i )) == null ? '' : __t) +
'" name="select_month" data-month="' +
((__t = ( I18n.t('date.month_names')[i] )) == null ? '' : __t) +
'" data-date-filter="month"/>\n						<label for="month_' +
((__t = ( i )) == null ? '' : __t) +
'" tabindex="0">' +
((__t = ( I18n.t('date.month_names')[i] )) == null ? '' : __t) +
'</label>\n					</li>\n				';
 } ;
__p += '\n			</ul>\n		</div>\n		<div class="dropdown_wrapper column_day">\n			<label>' +
((__t = ( I18n.t('uploader.common.filter.day') )) == null ? '' : __t) +
'</label>\n			<div id="day_selector" class="filter_item date_selector disabled" data-date-selector="day" tabindex="0">' +
((__t = ( I18n.t('uploader.common.filter.none') )) == null ? '' : __t) +
'</div>\n			<ul id="day_dropdown" class="date_dropdown">\n				';
 for(var i = 1; i <= 31; i++) { ;
__p += '\n					<li class="date_dropdown_item">\n						<input type="radio" id="day_' +
((__t = ( i )) == null ? '' : __t) +
'" value="' +
((__t = ( i )) == null ? '' : __t) +
'" name="select_day" data-date-filter="day" />\n						<label for="day_' +
((__t = ( i )) == null ? '' : __t) +
'" tabindex="0">' +
((__t = ( i )) == null ? '' : __t) +
'</label>\n					</li>\n				';
 } ;
__p += '\n			</ul>\n		</div>\n	</div>\n\n	<div class="drop_panel_buttons">\n		<button id="drop_panel_reset" class="google_button" tabindex="0">\n			' +
((__t = ( I18n.t('uploader.source.gphotos.filter.reset') )) == null ? '' : __t) +
'\n		</button>\n		<button id="drop_panel_apply" class="google_button" tabindex="0">\n			' +
((__t = ( I18n.t('uploader.source.gphotos.filter.apply') )) == null ? '' : __t) +
'\n		</button>\n	</div>\n</div>\n';

}
return __p
}